// 登录接口
import {
	axios
} from '../utils/http.js'

//获取售后分类列表
export function allAfterSalesCategory(data) {
	return axios({
		url: '/v3/AfterSalesCategory/All',
		method: 'post',
		data: data
	})
}
//添加售后分类
export function addAfterSalesCategory(data) {
	return axios({
		url: '/v3/AfterSalesCategory/Add',
		method: 'post',
		data: data
	})
}

//编辑售后分类
export function editAfterSalesCategory(data) {
	return axios({
		url: '/v3/AfterSalesCategory/Edit',
		method: 'post',
		data: data
	})
}
//删除售后分类
export function deleteAfterSalesCategory(data) {
	return axios({
		url: '/v3/AfterSalesCategory/Del',
		method: 'post',
		data: data
	})
}
//获取售后分类详情
export function getAfterSalesList(data) {
	return axios({
		url: '/v3/AfterSales/List',
		method: 'post',
		data: data
	})
}


//添加售后分类子项
export function addAfterSales(data) {
	return axios({
		url: '/v3/AfterSales/Add',
		method: 'post',
		data: data
	})
}

//编辑售后分类子项
export function editAfterSales(data) {
	return axios({
		url: '/v3/AfterSales/Edit',
		method: 'post',
		data: data
	})
}


//删除售后分类子项
export function deleteAfterSales(data) {
	return axios({
		url: '/v3/AfterSales/Del',
		method: 'post',
		data: data
	})
}
